import withInteractor from "./CompleteProfileBlock.interactor";
import withPresenter from "./CompleteProfileBlock.presenter";
import CompleteProfileBlockkView from "./CompleteProfileBlock.view";

const CompleteProfileBlock = withInteractor(
  withPresenter(CompleteProfileBlockkView),
);
export default CompleteProfileBlock;
